import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { List } from 'immutable';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FilterOperatorErrorRecord, { FILTER_OPERATOR_ERROR_CODES } from 'customer-data-filters-ui/filterQueryFormat/FilterOperatorErrorRecord';
import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
import { isEmptyValueOperator, isValidOperatorBase } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
import validateOperator from 'customer-data-filters-ui/filterQueryFormat/validateOperator';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import DeprecatedFilter from 'customer-data-filters-ui/filterQueryFormat/operator/DeprecatedFilter';
import { DATE_REFINEMENT, NUMBER_REFINEMENT } from 'customer-data-filters-ui/converters/objectSeg/constants/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultOptions = {
  shouldValidateRefinement: false
};
const validateConditionOperator = (condition, operatorLabel, validOperators) => {
  const isValidConditionOperator = condition.constructor === DeprecatedFilter || MissingField.isMissingField(condition.field) || condition && validOperators.has(condition.constructor);
  if (!isValidConditionOperator) {
    return FilterOperatorErrorRecord({
      error_code: FILTER_OPERATOR_ERROR_CODES.INVALID_OPERATOR,
      error: true,
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterEditorOperatorDisplayList.invalidOperator",
        options: {
          operatorType: operatorLabel || condition.constructor.toString()
        }
      })
    });
  }
  return undefined;
};
const validateMissingFieldWithError = condition => {
  const isMissingFieldWithError = Boolean(MissingField.isMissingField(condition.field) && condition.field.errorMessage);
  if (isMissingFieldWithError) {
    return FilterOperatorErrorRecord({
      error_code: FILTER_OPERATOR_ERROR_CODES.MISSING_FIELD_ERROR,
      error: true,
      message: condition.field.errorMessage
    });
  }
  return undefined;
};
const isValueNotInOptions = (value, options) => {
  return !options.find(option => option.value === value);
};
const validateValueOptions = (condition, fieldResolver) => {
  const field = condition.field;
  const canHaveInvalidOptions = field.displayType === ENUMERATION && field.options && field.options.size > 0 && !fieldResolver;
  if (!canHaveInvalidOptions) {
    return undefined;
  }
  let values = List();
  if (condition.constructor.isIterableField('value')) {
    values = condition.value;
  } else if (condition.value) {
    values = List([condition.value]);
  }
  const invalidOptions = values.filter(v => isValueNotInOptions(v, field.options));
  if (invalidOptions.size > 0) {
    const invalidOptionsJSX = /*#__PURE__*/_jsx(FormattedList, {
      exclusive: false,
      children: invalidOptions.map(value =>
      /*#__PURE__*/
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'Key | nu... Remove this comment to see the full error message
      _jsx("b", {
        children: value
      }, value))
    });
    return FilterOperatorErrorRecord({
      error_code: FILTER_OPERATOR_ERROR_CODES.INVALID_VALUE_OPTION,
      error: true,
      message: /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterEditorOperatorDisplayList.invalidOption.error",
          options: {
            count: invalidOptions.size,
            fieldName: condition.field.label,
            invalidOptions: invalidOptionsJSX
          }
        }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: "https://knowledge.hubspot.com/crm-setup/resolve-invalid-filter-errors",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.customerDataFilters.FilterEditorOperatorDisplayList.invalidOption.help"
          })
        })]
      })
    });
  }
  return undefined;
};
const validateEmptyRequiredValue = condition => {
  if (!isValidOperatorBase(condition) && isEmptyValueOperator(condition)) {
    return FilterOperatorErrorRecord({
      error_code: FILTER_OPERATOR_ERROR_CODES.VALUE_REQUIRED,
      error: true,
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterEditor.operatorErrors.valueRequired"
      })
    });
  }
  return undefined;
};
export const validateCondition = (condition, getIsUngated, options = {}) => {
  options = Object.assign({}, defaultOptions, options);
  const errors = [];

  // validate condition operator
  if (options.validOperators) {
    const invalidOperatorError = validateConditionOperator(condition, options.operatorLabel, options.validOperators);
    if (invalidOperatorError) {
      errors.push(invalidOperatorError);
    }
  }

  // validate for missing field with error
  const missingFieldError = validateMissingFieldWithError(condition);
  if (missingFieldError) {
    errors.push(missingFieldError);
  }

  // validate value options
  const invalidOptionsError = validateValueOptions(condition, options.fieldResolver);
  if (invalidOptionsError) {
    errors.push(invalidOptionsError);
  }

  // validate for missing required value
  const emptyValueError = validateEmptyRequiredValue(condition);
  if (emptyValueError) {
    errors.push(emptyValueError);
  }

  // carry over validation from old filters
  const operatorValidationError = validateOperator(condition, options.filterFamily, getIsUngated);
  if (operatorValidationError && operatorValidationError.error) {
    errors.push(operatorValidationError);
  }

  // validate refinements
  if (options.shouldValidateRefinement && condition.dateRefinement) {
    const validatedDateRefinement = validateCondition(condition.dateRefinement, getIsUngated);
    condition = condition.set(DATE_REFINEMENT, validatedDateRefinement);
  }
  if (options.shouldValidateRefinement && condition.numberRefinement) {
    const validatedNumberRefinement = validateCondition(condition.numberRefinement, getIsUngated);
    condition = condition.set(NUMBER_REFINEMENT, validatedNumberRefinement);
  }
  if (!errors.length) {
    return condition.remove('errors');
  }
  return condition.set('errors', errors);
};